var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return false ? _c('div', [_c('div', {
    staticClass: "popup_wrap kesh_image"
  }, [_c('div', {
    staticClass: "popup_title"
  }, [_c('p', [_vm._v("SAM2 Assisted EM Analysis")]), _c('a', {
    on: {
      "click": _vm.close
    }
  }, [_vm._m(0)])]), _c('div', {
    staticClass: "popup_content1"
  }, [_c('ul', {
    staticClass: "kesh_stage"
  }, [_c('li', {
    class: {
      'on': _vm.currentStep === 1
    }
  }, [_c('i', {
    staticClass: "kesh_num"
  }, [_vm._v("1")]), _c('p', {
    staticClass: "kesh_text"
  }, [_vm._v("이미지 설정")])]), _c('li', {
    class: {
      'on': _vm.currentStep === 2
    }
  }, [_c('i', {
    staticClass: "kesh_num"
  }, [_vm._v("2")]), _c('p', {
    staticClass: "kesh_text"
  }, [_vm._v("마스크 작업")])]), _c('li', {
    class: {
      'on': _vm.currentStep === 3
    }
  }, [_c('i', {
    staticClass: "kesh_num"
  }, [_vm._v("3")]), _c('p', {
    staticClass: "kesh_text"
  }, [_vm._v("분석 및 저장")])])]), _c('div', {
    staticClass: "sam2em-main-container"
  }, [_c('div', {
    staticClass: "sam2em-image-canvas-section"
  }, [_c('img', {
    ref: "processedImage",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "src": _vm.processedImageUrl,
      "alt": "Processing Image"
    },
    on: {
      "load": _vm.onImageLoad
    }
  }), _c('canvas', {
    ref: "imageCanvas",
    on: {
      "mousedown": _vm.handleMouseDown,
      "mousemove": _vm.handleMouseMove,
      "mouseup": _vm.handleMouseUp,
      "contextmenu": function ($event) {
        $event.preventDefault();
      }
    }
  })]), _c('div', {
    staticClass: "sam2em-controls-section"
  }, [_vm.currentStep === 1 ? _c('div', {
    staticClass: "control-group-wrapper"
  }, [_c('div', {
    staticClass: "control-group"
  }, [_vm._m(1), _c('label', {
    staticClass: "custom-file-upload",
    attrs: {
      "for": "file-upload"
    }
  }, [_vm._v(" " + _vm._s(_vm.selectedFile ? _vm.selectedFile.name : 'Choose a file...') + " ")]), _c('input', {
    attrs: {
      "id": "file-upload",
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.handleFileChange
    }
  }), _c('button', {
    attrs: {
      "disabled": !_vm.selectedFile
    },
    on: {
      "click": _vm.uploadImage
    }
  }, [_vm._v("Upload and Process Image")]), _vm.loadingStates.upload ? _c('div', {
    staticClass: "loader"
  }) : _vm._e(), _c('p', {
    staticClass: "status-message"
  }, [_vm._v(_vm._s(_vm.statusMessages.upload))])]), _c('div', {
    staticClass: "control-group"
  }, [_vm._m(2), _c('p', {
    staticClass: "guidance"
  }, [_vm._v("이미지 위의 빨간 선을 드래그하여 분석할 높이를 조절하세요. 완료 후 버튼을 눌러주세요.")]), _c('button', {
    attrs: {
      "disabled": !_vm.processedImageUrl
    },
    on: {
      "click": _vm.setPredictionImage
    }
  }, [_vm._v("Set SAM2 Input")]), _vm.loadingStates.setPrediction ? _c('div', {
    staticClass: "loader"
  }) : _vm._e(), _c('p', {
    staticClass: "status-message"
  }, [_vm._v(_vm._s(_vm.statusMessages.setPrediction))])]), _c('button', {
    staticClass: "btn_next_step",
    attrs: {
      "disabled": !_vm.isSamInputSet
    },
    on: {
      "click": _vm.nextStep
    }
  }, [_vm._v("다음 단계로")])]) : _vm._e(), _vm.currentStep === 2 ? _c('div', {
    staticClass: "control-group-wrapper"
  }, [_c('div', {
    staticClass: "control-group"
  }, [_vm._m(3), _vm._m(4), _c('button', {
    on: {
      "click": _vm.generateBatchMasks
    }
  }, [_vm._v("Generate Masks (Grid)")]), _vm.loadingStates.generate ? _c('div', {
    staticClass: "loader"
  }) : _vm._e(), _c('p', {
    staticClass: "status-message"
  }, [_vm._v(_vm._s(_vm.statusMessages.generate))])]), _c('div', {
    staticClass: "control-group"
  }, [_vm._m(5), _c('button', {
    class: {
      'active': _vm.isDrawingScaleBar
    },
    on: {
      "click": _vm.toggleDrawScaleBarMode
    }
  }, [_vm._v("Draw Scale Bar")]), _c('div', {
    staticClass: "inline-inputs"
  }, [_c('label', {
    attrs: {
      "for": "scaleBarLength"
    }
  }, [_vm._v("Length:")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.scaleBar.length,
      expression: "scaleBar.length",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "number",
      "min": "1"
    },
    domProps: {
      "value": _vm.scaleBar.length
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;

        _vm.$set(_vm.scaleBar, "length", _vm._n($event.target.value));
      },
      "blur": function ($event) {
        return _vm.$forceUpdate();
      }
    }
  }), _c('label', {
    attrs: {
      "for": "scaleBarUnit"
    }
  }, [_vm._v("Unit:")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.scaleBar.unit,
      expression: "scaleBar.unit"
    }],
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });

        _vm.$set(_vm.scaleBar, "unit", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "nm"
    }
  }, [_vm._v("nm")]), _c('option', {
    attrs: {
      "value": "μm"
    }
  }, [_vm._v("μm")])])]), _vm.loadingStates.scaleBar ? _c('div', {
    staticClass: "loader"
  }) : _vm._e(), _c('p', {
    staticClass: "status-message"
  }, [_vm._v(_vm._s(_vm.statusMessages.scaleBar))])]), _c('button', {
    staticClass: "btn_next_step",
    on: {
      "click": _vm.nextStep
    }
  }, [_vm._v("다음 단계로")])]) : _vm._e(), _vm.currentStep === 3 ? _c('div', {
    staticClass: "control-group-wrapper"
  }, [_c('div', {
    staticClass: "control-group"
  }, [_vm._m(6), _c('button', {
    class: {
      'active': _vm.showParticleFigure
    },
    on: {
      "click": _vm.toggleShowParticleFigure
    }
  }, [_vm._v("Show Particle Figure")]), _vm.loadingStates.particleFigure ? _c('div', {
    staticClass: "loader"
  }) : _vm._e(), _c('p', {
    staticClass: "status-message"
  }, [_vm._v(_vm._s(_vm.statusMessages.particleFigure))])]), _c('div', {
    staticClass: "control-group"
  }, [_vm._m(7), _c('button', {
    on: {
      "click": _vm.saveState
    }
  }, [_vm._v("Save Current State")]), _vm.loadingStates.saveState ? _c('div', {
    staticClass: "loader"
  }) : _vm._e(), _c('p', {
    staticClass: "status-message"
  }, [_vm._v(_vm._s(_vm.statusMessages.saveState))])])]) : _vm._e()])])]), _c('div', {
    staticClass: "popup_footer"
  }, [_c('a', {
    staticClass: "btn_type3",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("닫기")])])]), _c('div', {
    staticClass: "mask_wrap",
    staticStyle: {
      "display": "block"
    }
  })]) : _vm._e();

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "btn_close",
    attrs: {
      "title": "Close"
    }
  }, [_c('div', {
    staticClass: "btn_close_box"
  }, [_c('span'), _c('span')])]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "control-group-header"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Upload Image")])]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "control-group-header"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Set SAM2 Input")])]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "control-group-header"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Mask Generation")])]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('p', {
    staticClass: "guidance"
  }, [_vm._v(" - 좌클릭: 점 추가/삭제"), _c('br'), _vm._v(" - 우클릭 & 드래그: 박스 추가/삭제 ")]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "control-group-header"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Draw Scale Bar")])]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "control-group-header"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Show Particle Figure")])]);

},function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "control-group-header"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Save State")])]);

}]

export { render, staticRenderFns }